
/**
 * **表示形式の変更**（Issue #537）。反転・攻守の切り替え。
 *
 * 開く: `pos_change`。そのカードの位置で輪が回って締まる（**カードの回転そのものは盤が描く**
 * —— 器が `cardTurn` で向きを決めるので、演出は「変わった」ことだけを見せる）。
 */
const COLOR = '#35e0ff';

/** 状況ごとのファイル（`../effects/pos_change_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: '表示形式',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'set_card' }],

  opens({ payload }) {
    return payload?.zone || payload?.uid ? payload : null;
  },

  layers: [
    {
      id: 'spin',
      label: '回る輪',
      part: 'ring',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: COLOR, ticks: 6, width: 5 },
      tf: {
        scale: { keys: [{ ms: 0, value: 1.9 }, { ms: 300, value: 1, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 100, value: 0.95 }, { ms: 560, value: 0 }] },
        rotation: { keys: [{ ms: 0, value: -90 }, { ms: 560, value: 20 }] },
      },
    },
  ],
};
